import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";


function Blog() {

useEffect(() => {
AOS.init({ duration: 1000, once: true });
}, []);

  return (
    <div>
   <section className="home-blog" style={{overflowX:"hidden"}}>
  <div className="container">
    {/* Section Heading */}
    <div className="section-head text-center">
      <div className="row">
        <div className="col-lg-8 offset-lg-2" data-aos="fade-up">
          <div className="title-divider" />
          <h2 className="section-title">
            Our Insights And <span className="primary-color">Blog</span>
          </h2>
          <p>
            Stay updated with the latest trends, strategies, and ideas that
            help businesses grow smarter and faster.
          </p>
        </div>
      </div>
    </div>

    {/* Blog Posts */}
    <div className="row" >
      <div className="col-md-6 col-lg-4" data-aos="fade-left">
        <article className="post">
          <figure className="feature-image">
            <a href="/Portfolio">
              <img src="assets/images/img21.jpg" alt="Business Collaboration" />
            </a>
          </figure>
          <div className="entry-content">
            <h4>
              <a href="/Portfolio">
              Customer-to-customer marketplace mobile app with chat support
              </a>
            </h4>
            {/* <div className="entry-meta">
              <span className="byline">
                <a href="/Portfolio">Admin</a>
              </span>
              <span className="posted-on">
                <a href="/Portfolio">July 12, 2023</a>
              </span>
              <span className="comments-link">
                <a href="/Portfolio">3 Comments</a>
              </span> 
            </div>*/}
          </div>
        </article>
      </div>

      <div className="col-md-6 col-lg-4" data-aos="fade-left" data-aos-delay="200">
        <article className="post">
          <figure className="feature-image">
            <a href="/Portfolio">
              <img src="assets/images/img22.jpg" alt="Daily Productivity Tips" />
            </a>
          </figure>
          <div className="entry-content">
            <h4>
              <a href="/Portfolio">
              Survey automation platform that simplifies data collection, analysis
              </a>
            </h4>
            {/* <div className="entry-meta">
              <span className="byline">
                <a href="/Portfolio">Admin</a>
              </span>
              <span className="posted-on">
                <a href="/Portfolio">August 05, 2023</a>
              </span>
              <span className="comments-link">
                <a href="/Portfolio">5 Comments</a>
              </span>
            </div> */}
          </div>
        </article>
      </div>

      <div className="col-md-6 col-lg-4" data-aos="fade-left" data-aos-delay="250">
        <article className="post">
          <figure className="feature-image">
            <a href="/Portfolio">
              <img src="assets/images/img23.jpg" alt="Social Media Strategy" />
            </a>
          </figure>
          <div className="entry-content">
            <h4>
              <a href="/Portfolio">
              Fresh produce e-commerce website with subscription options,
              </a>
            </h4>
            {/* <div className="entry-meta">
              <span className="byline">
                <a href="/Portfolio">Admin</a>
              </span>
              <span className="posted-on">
                <a href="/Portfolio">September 10, 2023</a>
              </span>
              <span className="comments-link">
                <a href="/Portfolio">7 Comments</a>
              </span>
            </div> */}
          </div>
        </article>
      </div>
    </div>
  </div>
</section>


    </div>
  )
}

export default Blog
